import { render } from "./GameStats.vue?vue&type=template&id=a113a06a"
import script from "./GameStats.vue?vue&type=script&lang=js"
export * from "./GameStats.vue?vue&type=script&lang=js"

import "./GameStats.vue?vue&type=style&index=0&id=a113a06a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__